import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/Auth/auth.service';
import { DashboardAccountsComponent } from "./dashboard-accounts/dashboard-accounts.component";
import { CommonModule } from '@angular/common';
import { DashboardAllAccountsComponent } from "./dashboard-all-accounts/dashboard-all-accounts.component";
import { DashboardBookingRequestsComponent } from "./dashboard-booking-requests/dashboard-booking-requests.component";
import { DashboardBookingConfirmedComponent } from "./dashboard-booking-confirmed/dashboard-booking-confirmed.component";
import { DashboardBookingPastComponent } from "./dashboard-booking-past/dashboard-booking-past.component";
import { DashboardBookingOverlayComponent } from "./dashboard-booking-overlay/dashboard-booking-overlay.component";
import { BookingService } from '../../services/Booking/booking.service';
import { DashboardBookingDeniedComponent } from "./dashboard-booking-denied/dashboard-booking-denied.component";
import { DashboardDeletedAccountsComponent } from './dashboard-deleted-accounts/dashboard-deleted-accounts.component';
import { DashboardDeleteOverlayComponent } from "./dashboard-delete-overlay/dashboard-delete-overlay.component";

@Component({
    selector: 'app-dashboard',
    imports: [
    CommonModule,
    DashboardAccountsComponent,
    DashboardAllAccountsComponent,
    DashboardBookingRequestsComponent,
    DashboardBookingConfirmedComponent,
    DashboardBookingPastComponent,
    DashboardBookingOverlayComponent,
    DashboardBookingDeniedComponent,
    DashboardDeletedAccountsComponent,
    DashboardDeleteOverlayComponent
],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
    public section: string
    public subSection: string

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService,
        public bookingService : BookingService
    ) {
        this.section = "accounts"
        this.subSection = "requests"
    }

    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(params => {
            const section = params.get('id'); // 'id' is the parameter name from your route
            if (section) {
                this.section = section
            }

            const subSection = params.get('subSection'); // 'id' is the parameter name from your route
            if (subSection) {
                this.subSection = subSection
            }
        });
    }
}
